/** ASM widget customizations */
var asmActiveInstance = null;
var asmObserverInitialized = false;

var CG_SHIP_ZIP_KEY = 'cg_shipping_zip';
var CG_SHIP_STATE_KEY = 'cg_shipping_state';
var CG_SHIP_COUNTRY_KEY = 'cg_shipping_country';

function getAsmInstance(instanceId) {
  return document.querySelector('[data-asm-instance="' + instanceId + '"]');
}

function getPrimaryAsmInstance() {
  return document.querySelector('.asm-shipping-calc--primary');
}

function getGlobalCalcResults() {
  return (
    document.querySelector('.asm-shipping-calc--primary #calc_results') ||
    document.getElementById('calc_results')
  );
}

function getVisibleCalcZip() {
  return (
    document.querySelector('.asm-shipping-calc--primary #calc_zip') ||
    document.getElementById('calc_zip')
  );
}

function getActiveAsmInstance() {
  if (asmActiveInstance) {
    var activeInstance = getAsmInstance(asmActiveInstance);
    if (activeInstance) return activeInstance;
  }

  return (
    getPrimaryAsmInstance() ||
    document.querySelector('.asm-shipping-calc[data-asm-context="product"]') ||
    document.querySelector('.asm-shipping-calc[data-asm-context="cart"]') ||
    document.querySelector('.asm-shipping-calc')
  );
}

function cgGetSavedShippingAddress() {
  try {
    return {
      zip: sessionStorage.getItem(CG_SHIP_ZIP_KEY) || '',
      state: sessionStorage.getItem(CG_SHIP_STATE_KEY) || '',
      country: sessionStorage.getItem(CG_SHIP_COUNTRY_KEY) || '',
    };
  } catch (e) {
    return { zip: '', state: '', country: '' };
  }
}

function cgNormalizeShippingCountry(country) {
  if (!country) return 'United States';
  if (country === 'US' || country === 'USA') return 'United States';
  return country;
}

function cgSaveShippingAddress(data) {
  if (!data) return;
  try {
    if (data.zip) sessionStorage.setItem(CG_SHIP_ZIP_KEY, String(data.zip).trim());
    if (data.state) sessionStorage.setItem(CG_SHIP_STATE_KEY, data.state);
    if (data.country) sessionStorage.setItem(CG_SHIP_COUNTRY_KEY, cgNormalizeShippingCountry(data.country));
  } catch (e) {}
}

function cgFormatShippingPrice(price) {
  if (price === '0.00' || price === 0 || price === '0') {
    return 'FREE';
  }
  var format =
    (typeof global_setting_currency !== 'undefined' && global_setting_currency) ||
    (window.theme && theme.moneyFormat) ||
    '${{amount}}';
  var amountStr = typeof price === 'number' ? price.toFixed(2) : String(price);
  return format
    .replace('{{amount}}', amountStr)
    .replace('{{amount_no_decimals}}', amountStr.replace(/\.00$/, ''));
}

function cgParseMoneyAmount(rateText) {
  if (!rateText) return null;
  var normalized = String(rateText).replace(/,/g, '').trim();
  if (/^free$/i.test(normalized)) return 0;
  var match = normalized.match(/(\d+(\.\d+)?)/);
  if (!match) return null;
  var amount = parseFloat(match[1]);
  return isNaN(amount) ? null : amount;
}

function cgGetPdpVariantId() {
  var instance = getPrimaryAsmInstance() || getActiveAsmInstance();
  return (
    (instance && instance.dataset.asmVariantId) ||
    window.cgAsmPdpVariantId ||
    ''
  );
}

function cgGetPdpCartLineQtySync() {
  var qtyInput = document.getElementById('Quantity');
  var attrQty = qtyInput && parseInt(qtyInput.getAttribute('data-cart-quantity'), 10);
  if (attrQty > 0) return attrQty;

  var variantId = String(cgGetPdpVariantId());
  if (variantId && window.__cgCartLineQtyByVariant && window.__cgCartLineQtyByVariant[variantId] > 0) {
    return window.__cgCartLineQtyByVariant[variantId];
  }
  return 1;
}

function cgFetchPdpCartLineQty() {
  var variantId = String(cgGetPdpVariantId());
  return fetch('/cart.js')
    .then(function (res) {
      return res.json();
    })
    .then(function (cart) {
      var lineQty = 0;
      (cart.items || []).forEach(function (item) {
        if (String(item.variant_id) === variantId || String(item.id) === variantId) {
          lineQty += item.quantity;
        }
      });
      window.__cgCartLineQtyByVariant = window.__cgCartLineQtyByVariant || {};
      if (variantId) window.__cgCartLineQtyByVariant[variantId] = lineQty;
      return lineQty > 0 ? lineQty : 1;
    })
    .catch(function () {
      return cgGetPdpCartLineQtySync();
    });
}

/** PDP should show cost to ship one unit: line shipping total / cart line qty. */
function cgToPerUnitShippingRate(rateText, divisor) {
  if (!rateText) return rateText;
  if (/free/i.test(String(rateText).trim())) return rateText;

  var qty = parseInt(divisor, 10) || 1;
  if (qty <= 1) return rateText;

  var amount = cgParseMoneyAmount(rateText);
  if (amount === null) return rateText;

  var perUnit = amount / qty;
  var formatted = cgFormatShippingPrice(perUnit);
  console.log('[ASM calc] PDP per-unit rate:', {
    lineTotal: rateText,
    cartLineQty: qty,
    perUnit: formatted,
  });
  return formatted;
}

function cgLowestShopifyRate(shippingMethods) {
  if (!shippingMethods || !shippingMethods.shipping_rates || !shippingMethods.shipping_rates.length) {
    return '';
  }
  var filtered = shippingMethods.shipping_rates.filter(function (method) {
    var name = (method.name || '').toLowerCase();
    return name.indexOf('pickup') === -1 && name.indexOf('pick-up') === -1 && method.price !== '';
  });
  if (!filtered.length) return '';
  var lowest = filtered.reduce(function (min, current) {
    return parseFloat(current.price) < parseFloat(min.price) ? current : min;
  }, filtered[0]);
  return cgFormatShippingPrice(lowest.price);
}

function cgLookupStateForZip(zip) {
  var cleanZip = String(zip || '')
    .replace(/\D/g, '')
    .slice(0, 5);
  if (cleanZip.length < 5) {
    return Promise.resolve(cgGetSavedShippingAddress().state || '');
  }
  return fetch('https://api.zippopotam.us/us/' + cleanZip)
    .then(function (res) {
      return res.ok ? res.json() : null;
    })
    .then(function (data) {
      if (data && data.places && data.places[0]) {
        return data.places[0].state || data.places[0]['state abbreviation'] || '';
      }
      return cgGetSavedShippingAddress().state || '';
    })
    .catch(function () {
      return cgGetSavedShippingAddress().state || '';
    });
}

function cgFetchShopifyShippingRates(zip, country, state) {
  var url =
    '/cart/shipping_rates.json?shipping_address[zip]=' +
    encodeURIComponent(zip) +
    '&shipping_address[country]=' +
    encodeURIComponent(cgNormalizeShippingCountry(country));
  if (state) {
    url += '&shipping_address[province]=' + encodeURIComponent(state);
  }
  return fetch(url).then(function (res) {
    return res.json();
  });
}

function cgWithProductInCartForRates(variantId, qty, fn, options) {
  options = options || {};
  var isolate = options.isolate !== false;
  var id = String(variantId || '');
  var quantity = parseInt(qty, 10) || 1;

  if (!isolate) {
    return Promise.resolve(fn());
  }

  if (!id) return fn();

  window.__cgSkipCartGeo = true;
  return fetch('/cart.js')
    .then(function (res) {
      return res.json();
    })
    .then(function (originalCart) {
      var originalUpdates = {};
      originalCart.items.forEach(function (item) {
        originalUpdates[String(item.variant_id)] = item.quantity;
      });

      var alreadyIsolated =
        originalCart.items.length === 1 &&
        String(originalCart.items[0].variant_id) === id &&
        Number(originalCart.items[0].quantity) === quantity;

      if (alreadyIsolated) {
        return fn();
      }

      var isolateUpdates = {};
      Object.keys(originalUpdates).forEach(function (vid) {
        isolateUpdates[vid] = 0;
      });
      isolateUpdates[id] = quantity;

      console.log('[ASM calc] Isolating cart to variant', id, 'qty', quantity, 'for PDP item-only rate');

      var isolatePromise =
        originalCart.item_count < 1
          ? fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({ id: Number(id), quantity: quantity }),
            })
          : fetch('/cart/update.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({ updates: isolateUpdates }),
            });

      return isolatePromise
        .then(function (res) {
          if (!res.ok) throw new Error('cart isolate failed');
          return fn();
        })
        .then(function (result) {
          if (originalCart.item_count < 1) {
            var clearUpdates = {};
            clearUpdates[id] = 0;
            return fetch('/cart/update.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({ updates: clearUpdates }),
            }).then(function () {
              return result;
            });
          }

          return fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ updates: originalUpdates }),
          }).then(function () {
            return result;
          });
        });
    })
    .finally(function () {
      window.__cgSkipCartGeo = false;
    });
}

function syncInstanceZipToGlobal(instance) {
  if (!instance) return;

  var zipInput = instance.querySelector('[data-asm-zip-input]');
  var globalZip = getVisibleCalcZip();

  if (zipInput && globalZip && zipInput !== globalZip) {
    globalZip.value = zipInput.value;
  }
}

function syncGlobalZipToInstance(instance) {
  if (!instance) return;

  var zipInput = instance.querySelector('[data-asm-zip-input]');
  var globalZip = getVisibleCalcZip();

  if (zipInput && globalZip && zipInput.value === '' && globalZip.value !== '') {
    zipInput.value = globalZip.value;
  }
}

function syncGlobalZipToInstances(excludeInput) {
  var globalZip = getVisibleCalcZip();
  if (!globalZip) return;

  document.querySelectorAll('[data-asm-zip-input]').forEach(function (input) {
    if (excludeInput && input === excludeInput) return;
    input.value = globalZip.value;
  });
}

function cgIsCartAsmInstance(instance) {
  if (!instance) return false;
  var id = instance.dataset.asmInstance || '';
  return (
    instance.dataset.asmContext === 'cart' ||
    id === 'cart-drawer' ||
    id === 'cart-page'
  );
}

function syncResultsToSecondaryInstances(customHtml) {
  // Never mirror PDP rates into the cart calculator — cart uses full-cart Shopify rates.
  document
    .querySelectorAll('.asm-shipping-calc:not(.asm-shipping-calc--primary) [data-asm-results]')
    .forEach(function (resultsElement) {
      var instance = resultsElement.closest('.asm-shipping-calc');
      if (cgIsCartAsmInstance(instance)) return;
      resultsElement.innerHTML = customHtml;
    });
}

function syncZipToSecondaryInstances() {
  syncGlobalZipToInstances();
}

function cgDeduplicateAsmCalcIds() {
  var hidden = document.getElementById('kwm-product-ship-calc');
  if (!hidden) return;

  hidden.querySelectorAll('#calc_zip').forEach(function (el) {
    el.id = 'asm_hidden_calc_zip';
  });
  hidden.querySelectorAll('#calc_results').forEach(function (el) {
    el.id = 'asm_hidden_calc_results';
  });
}

function cgWatchHiddenAsmInject() {
  var hidden = document.getElementById('kwm-product-ship-calc');
  if (!hidden || hidden._cgDedupeObserved) return;
  hidden._cgDedupeObserved = true;
  var observer = new MutationObserver(function () {
    cgDeduplicateAsmCalcIds();
  });
  observer.observe(hidden, { childList: true, subtree: true });
  cgDeduplicateAsmCalcIds();
}

function copyZipValue() {
  var visibleZip = getVisibleCalcZip();
  if (!visibleZip) return;

  if (visibleZip.value !== '') {
    syncGlobalZipToInstances();
    return;
  }

  var saved = cgGetSavedShippingAddress();
  if (saved.zip) {
    visibleZip.value = saved.zip;
    syncGlobalZipToInstances();
    return;
  }

  var inputFrom = document.querySelector(
    '#kwm-product-ship-calc #calc_zip, #kwm-product-ship-calc #asm_hidden_calc_zip'
  );
  if (inputFrom && inputFrom.value) {
    visibleZip.value = inputFrom.value;
    syncGlobalZipToInstances();
  }
}

function cgApplyZipToAllInputs(zip) {
  if (!zip) return;
  var visibleZip = getVisibleCalcZip();
  if (visibleZip) visibleZip.value = zip;
  document.querySelectorAll('[data-asm-zip-input]').forEach(function (input) {
    input.value = zip;
  });
  document
    .querySelectorAll('#kwm-product-ship-calc #calc_zip, #kwm-product-ship-calc #asm_hidden_calc_zip')
    .forEach(function (el) {
      el.value = zip;
    });
}

function ShippingCalcThru() {
  var instance = getActiveAsmInstance();
  if (!instance) return;

  asmActiveInstance = instance.dataset.asmInstance;
  cgDeduplicateAsmCalcIds();
  syncInstanceZipToGlobal(instance);
  syncGlobalZipToInstance(instance);
  copyZipValue();

  var visibleZip = getVisibleCalcZip();
  var sku = instance.dataset.asmSku;
  var price = instance.dataset.asmPrice;
  var quantityInput = document.getElementById('Quantity');
  var qty =
    instance.dataset.asmContext === 'product' && quantityInput
      ? quantityInput.value
      : instance.dataset.asmQty || 1;

  window.__cgAsmThruTries = (window.__cgAsmThruTries || 0) + 1;
  var zipReady = visibleZip && visibleZip.value !== '';
  var qtyReady = instance.dataset.asmContext !== 'product' || quantityInput;

  if (typeof ShippingCalc !== 'function' || !qtyReady || (!zipReady && window.__cgAsmThruTries < 50)) {
    setTimeout(ShippingCalcThru, 100);
    return;
  }

  if (typeof ShippingCalc === 'function' && sku && zipReady) {
    ShippingCalc(sku, price, qty);
  }
}

function CityGroundsInit() {
  copyZipValue();
  var qtyEl = document.getElementById('Quantity');
  var zipEl = getVisibleCalcZip();
  var instance = getActiveAsmInstance();
  var needsQty = instance && instance.dataset.asmContext === 'product';

  window.__cgAsmInitTries = (window.__cgAsmInitTries || 0) + 1;
  if (typeof ShippingCalc === 'function' && (!needsQty || qtyEl) && zipEl && zipEl.value) {
    ShippingCalcThru();
  } else if (window.__cgAsmInitTries < 50) {
    setTimeout(CityGroundsInit, 100);
  } else if (typeof ShippingCalcThru === 'function' && zipEl && zipEl.value) {
    ShippingCalcThru();
  }
}

function cgHideElement(element) {
  element.style.display = 'none';
}

function cgRenderPdpShipsTo(resultsEl, zip, rateText, source) {
  cgRenderShipsTo(resultsEl, zip, rateText, source, { syncSecondaries: true });
}

function cgRenderCartShipsTo(resultsEl, zip, rateText, source) {
  cgRenderShipsTo(resultsEl, zip, rateText, source, { syncSecondaries: false });
}

function cgRenderShipsTo(resultsEl, zip, rateText, source, options) {
  if (!resultsEl || !zip) return;
  options = options || {};

  var iconTruck = document.getElementById('iconTruck');
  if (!iconTruck) {
    iconTruck = document.querySelector('.asm-shipping-calc__icon-truck');
  }
  var truckIcon = iconTruck ? iconTruck.innerHTML : '';
  var rateLabel = rateText ? ' for ' + rateText : '';
  var html = truckIcon + 'Ships to: <strong>' + zip + rateLabel + '</strong>';
  var existing = resultsEl.querySelector('.cg_calc_text');

  console.log('[ASM calc] Showing from ' + (source || 'unknown') + ':', {
    zip: zip,
    rate: rateText || '(none)',
    display: 'Ships to: ' + zip + rateLabel,
  });

  if (existing) {
    existing.innerHTML = html;
  } else {
    var loader = resultsEl.querySelector('#calc-image-loader');
    if (loader) loader.remove();
    var node = document.createElement('div');
    node.className = 'cg_calc_text';
    node.innerHTML = html;
    resultsEl.insertBefore(node, resultsEl.firstChild);
  }

  if (options.syncSecondaries !== false) {
    syncResultsToSecondaryInstances(
      resultsEl.querySelector('.cg_calc_text')
        ? resultsEl.querySelector('.cg_calc_text').outerHTML
        : html
    );
  }
  syncZipToSecondaryInstances();
}

function cgFillPdpRateFromShopify(resultsEl, zipValue, options) {
  if (!resultsEl || !zipValue) return Promise.resolve();
  options = options || {};
  var isolate = options.isolate !== false;

  var instance = getActiveAsmInstance() || getPrimaryAsmInstance();
  var qtyEl = document.getElementById('Quantity');
  var variantId = (instance && instance.dataset.asmVariantId) || window.cgAsmPdpVariantId;
  var saved = cgGetSavedShippingAddress();

  return cgLookupStateForZip(zipValue)
    .then(function (state) {
      if (state) {
        cgSaveShippingAddress({
          zip: zipValue,
          state: state,
          country: saved.country || 'United States',
        });
      } else {
        cgSaveShippingAddress({
          zip: zipValue,
          country: saved.country || 'United States',
        });
      }
      var qty = qtyEl ? qtyEl.value : instance && instance.dataset.asmQty;
      return cgWithProductInCartForRates(
        variantId,
        qty,
        function () {
          return cgFetchShopifyShippingRates(zipValue, saved.country || 'United States', state);
        },
        { isolate: isolate }
      );
    })
    .then(function (rateData) {
      console.log(
        '[ASM calc] Shopify /cart/shipping_rates.json response' +
          (isolate ? ' (PDP isolated)' : ' (full cart)') +
          ':',
        rateData
      );
      var rateText = cgLowestShopifyRate(rateData);
      console.log('[ASM calc] Shopify selected (lowest non-pickup) price:', rateText || '(none)');
      if (!rateText) return;

      if (!isolate) {
        cgRenderCartShipsTo(resultsEl, zipValue, rateText, 'Shopify-cart');
        return;
      }

      // PDP: show per-unit cost (line total / cart line qty).
      return cgFetchPdpCartLineQty().then(function (lineQty) {
        var perUnit = cgToPerUnitShippingRate(rateText, lineQty);
        cgRenderPdpShipsTo(resultsEl, zipValue, perUnit, 'Shopify-PDP-per-unit');
      });
    })
    .catch(function (err) {
      console.warn('[ASM calc] Shopify rates fetch failed:', err);
    });
}

function pdpAsmCalcCustomContent(ajaxNode) {
  var iconTruck = document.getElementById('iconTruck');
  var zipValue = getVisibleCalcZip() ? getVisibleCalcZip().value : '';
  var ratesElement = ajaxNode.querySelector('.ajax_rates') || document.querySelector('.ajax_rates');
  var ratesText = ratesElement ? ratesElement.innerText.trim() : '';
  var truckIcon = iconTruck ? iconTruck.innerHTML : '';
  var calcResults = getGlobalCalcResults();

  if (!calcResults) return;

  console.log('[ASM calc] ASM product_calc response node:', ajaxNode);
  console.log('[ASM calc] ASM .ajax_rates text:', ratesText || '(empty / missing)');
  console.log('[ASM calc] ASM ajax_results HTML:', ajaxNode.innerHTML);

  var loader = calcResults.querySelector('#calc-image-loader');
  if (loader) loader.remove();

  if (zipValue && !ratesText) {
    console.log('[ASM calc] ASM returned no rate — falling back to Shopify');
    cgFillPdpRateFromShopify(calcResults, zipValue);
    return;
  }

  if (!ratesText) {
    var emptyNode = document.createElement('div');
    emptyNode.classList.add('cg_calc_text');
    emptyNode.innerHTML = truckIcon + 'Ships to: <strong>' + zipValue + '</strong>';
    calcResults.innerHTML = '';
    calcResults.appendChild(emptyNode);
    return;
  }

  // Show ASM line total immediately, then replace with per-unit once cart qty is known.
  var syncQty = cgGetPdpCartLineQtySync();
  var initialRate = cgToPerUnitShippingRate(ratesText, syncQty);
  cgRenderPdpShipsTo(calcResults, zipValue, initialRate, 'ASM');

  cgFetchPdpCartLineQty().then(function (lineQty) {
    if (lineQty === syncQty) return;
    var perUnit = cgToPerUnitShippingRate(ratesText, lineQty);
    cgRenderPdpShipsTo(calcResults, zipValue, perUnit, 'ASM-per-unit');
  });

  if (zipValue) {
    cgSaveShippingAddress({ zip: zipValue, country: 'United States' });
  }
}

function handleAjaxResults(ajaxNode) {
  pdpAsmCalcCustomContent(ajaxNode);
  cgHideElement(ajaxNode);
}

function scanForExistingAjaxResults() {
  var calcResults = getGlobalCalcResults();
  if (!calcResults) return;
  var ajaxResults = calcResults.querySelector('#ajax_results') || document.getElementById('ajax_results');
  if (ajaxResults) {
    handleAjaxResults(ajaxResults);
  }
}

function cgAsmPdpShowFallback(results) {
  if (!results) return;

  var zipInput = getVisibleCalcZip();
  var zipValue = zipInput ? zipInput.value : '';
  if (!zipValue) return;

  var existing = results.querySelector('.cg_calc_text');
  if (existing && existing.innerText.indexOf(' for ') !== -1) return;

  cgRenderPdpShipsTo(results, zipValue, '', 'ASM-timeout');
  cgFillPdpRateFromShopify(results, zipValue);
}

function cgWatchPdpCalcResults(targetNode) {
  if (!targetNode) return;
  if (targetNode._cgWatchTimer) {
    clearInterval(targetNode._cgWatchTimer);
  }
  var tries = 0;
  targetNode._cgWatchTimer = setInterval(function () {
    tries++;
    if (targetNode.querySelector('.cg_calc_text') || targetNode.querySelector('#ajax_results')) {
      pdpAsmProcessResults(targetNode);
      clearInterval(targetNode._cgWatchTimer);
      targetNode._cgWatchTimer = null;
      return;
    }
    if (tries >= 40) {
      clearInterval(targetNode._cgWatchTimer);
      targetNode._cgWatchTimer = null;
      cgAsmPdpShowFallback(targetNode);
    }
  }, 200);
}

function pdpAsmProcessResults(root) {
  if (!root) return;
  var ajaxResults = root.querySelector('#ajax_results');
  if (!ajaxResults) return;

  if (root.querySelector('.cg_calc_text')) {
    cgHideElement(ajaxResults);
    var loader = root.querySelector('#calc-image-loader');
    if (loader) loader.remove();
    return;
  }

  pdpAsmCalcCustomContent(ajaxResults);
  cgHideElement(ajaxResults);
  var loaderEl = root.querySelector('#calc-image-loader');
  if (loaderEl) loaderEl.remove();
}

function pdpAsmCalcObserver() {
  if (asmObserverInitialized) return;

  var targetNode = getGlobalCalcResults();
  if (!targetNode) return;

  var observer = new MutationObserver(function (mutationsList) {
    for (var mutation of mutationsList) {
      if (mutation.type !== 'childList') continue;

      mutation.addedNodes.forEach(function (node) {
        if (node.nodeType !== 1 || node.id !== 'ajax_results') return;
        handleAjaxResults(node);
      });
    }
  });

  observer.observe(targetNode, {
    childList: true,
    subtree: true,
  });

  asmObserverInitialized = true;
  scanForExistingAjaxResults();
  cgWatchPdpCalcResults(targetNode);
}

function cgAsmShowEditor(instance) {
  if (!instance) return;

  var editLink = instance.querySelector('.cg_shipping_calc__edit a');
  var editWrap = instance.querySelector('.cg_shipping_calc');
  var shipCalc = instance.querySelector('.ship_calc');
  var results = instance.querySelector('#calc_results, [data-asm-results]');

  if (editLink) editLink.classList.add('hidden');
  if (editWrap) editWrap.classList.add('cg_shipping_calc--full');
  if (shipCalc) shipCalc.style.display = 'flex';
  if (results) results.classList.add('shouldHide');
}

function cgAsmShowResults(instance) {
  if (!instance) return;

  var editLink = instance.querySelector('.cg_shipping_calc__edit a');
  var editWrap = instance.querySelector('.cg_shipping_calc');
  var shipCalc = instance.querySelector('.ship_calc');
  var results = instance.querySelector('#calc_results, [data-asm-results]');

  if (editLink) editLink.classList.remove('hidden');
  if (editWrap) editWrap.classList.remove('cg_shipping_calc--full');
  if (shipCalc) shipCalc.style.display = 'none';
  if (results) results.classList.remove('shouldHide');
}

function cgAsmCalcSubmit(instance) {
  if (!instance) return;

  asmActiveInstance = instance.dataset.asmInstance;
  syncInstanceZipToGlobal(instance);
  cgAsmCalcPDPSubmit();
}

function cgAsmCalcPDPSubmit() {
  syncInstanceZipToGlobal(getActiveAsmInstance());
  copyZipValue();

  var zipInput = getVisibleCalcZip();
  if (zipInput && zipInput.value) {
    cgSaveShippingAddress({ zip: zipInput.value, country: 'United States' });
  }

  if (typeof ValidateShippingCalc === 'function') {
    ValidateShippingCalc();
  }

  window.__cgAsmThruTries = 0;
  ShippingCalcThru();

  document.querySelectorAll('.asm-shipping-calc').forEach(function (calcInstance) {
    cgAsmShowResults(calcInstance);
  });
}

function cgAsmToggleEditForInstance(instance, event) {
  if (!instance) return;

  if (event) {
    event.preventDefault();
  }

  syncInstanceZipToGlobal(instance);
  syncGlobalZipToInstance(instance);
  copyZipValue();
  cgAsmShowEditor(instance);
}

function cgAsmPDPToggleEditAddr(event) {
  var instance =
    event && event.target ? event.target.closest('.asm-shipping-calc') : getPrimaryAsmInstance();
  cgAsmToggleEditForInstance(instance, event || false);
}

function cgPDPAsmCalcPreventEnter(evt) {
  evt = evt || event;
  var charCode = evt.charCode ? evt.charCode : evt.which ? evt.which : evt.keyCode;
  return charCode !== 13;
}

function ShippingCalcc(item_id, item_price, item_qty, optional_message) {
  if (optional_message === undefined) optional_message = '';

  var unit_price = item_price;
  var jsel = document.createElement('SCRIPT');
  jsel.type = 'text/javascript';
  var globalZip = getVisibleCalcZip();
  var zipValue = globalZip ? globalZip.value : '';
  var calcResults = getGlobalCalcResults();
  var asmAjax = document.getElementById('asm-ajax');

  if (document.getElementById('calc_country')) {
    jsel.src =
      '//www.advancedshippingmanager.com/clients/calcs/product/product_calc.php?si=' +
      asm_store_id +
      '&id=' +
      item_id +
      '&zip=' +
      zipValue +
      '&country=' +
      document.getElementById('calc_country').value +
      '&qty=' +
      item_qty +
      '&up=' +
      unit_price;
  } else if (
    asm_store_id == 'woodenwonderland' ||
    asm_store_id == 'tools-warehouse-2018' ||
    asm_store_id == 'xsnp47c4d3'
  ) {
    jsel.src =
      '//www.advancedshippingmanager.com/clients/calcs/product/product_calc.php?si=' +
      asm_store_id +
      '&id=' +
      item_id +
      '&zip=' +
      zipValue +
      '&country=AU&qty=' +
      item_qty +
      '&up=' +
      unit_price;
  } else {
    jsel.src =
      '//www.advancedshippingmanager.com/clients/calcs/product/product_calc.php?si=' +
      asm_store_id +
      '&id=' +
      item_id +
      '&zip=' +
      zipValue +
      '&country=US&qty=' +
      item_qty +
      '&up=' +
      unit_price +
      '&note=' +
      optional_message;
  }

  if (calcResults) {
    calcResults.innerHTML =
      '<div id="calc-image-loader" style="text-align: center;"><img src="//www.advancedshippingmanager.com/clients/calcs/product/image_loaders/' +
      asm_store_id +
      '.gif" border="0" style="margin-left: auto; margin-right: auto;" /></div>';
    calcResults.style.paddingTop = '10';
  }

  if (asmAjax) asmAjax.appendChild(jsel);
}

function cgWrapShippingCalc() {
  if (typeof ShippingCalc !== 'function') {
    setTimeout(cgWrapShippingCalc, 50);
    return;
  }
  if (ShippingCalc.__cgWrapped) return;

  var original = ShippingCalc;
  function wrappedShippingCalc(item_id, item_price, item_qty, optional_message) {
    copyZipValue();
    cgDeduplicateAsmCalcIds();
    original(item_id, item_price, item_qty, optional_message);
    var results = getGlobalCalcResults();
    var zipInput = getVisibleCalcZip();
    if (zipInput && zipInput.value) {
      cgSaveShippingAddress({ zip: zipInput.value, country: 'United States' });
      // Shopify is fallback only (via watch/empty ASM). Do not overwrite ASM with cart-total rates.
      console.log('[ASM calc] ShippingCalc fired for SKU', item_id, '— waiting for ASM; Shopify only if ASM has no rate');
    }
    cgWatchPdpCalcResults(results);
  }
  wrappedShippingCalc.__cgWrapped = true;
  ShippingCalc = wrappedShippingCalc;
}
cgWrapShippingCalc();

function fetchCart() {
  return fetch('/cart.js')
    .then(function (response) {
      return response.json();
    })
    .catch(function (error) {
      console.error('Error fetching cart:', error);
      return null;
    });
}

function cgAsmGeolocationScript(apiUrl) {
  var script = document.createElement('script');
  script.src = apiUrl;
  document.body.appendChild(script);
}

function cgAsmPopulatePdpCalcFields(data) {
  if (!data || !data.zip) return;

  var saved = cgGetSavedShippingAddress();
  if (!saved.zip) {
    cgSaveShippingAddress(data);
  }
  var zipToUse = saved.zip || data.zip;
  cgApplyZipToAllInputs(zipToUse);

  if (typeof ShippingCalc === 'function') {
    window.__cgAsmThruTries = 0;
    CityGroundsInit();
  }
}

function cgAsmPopulateCalcFields(data) {
  if (window.__cgSkipCartGeo) return;

  var saved = cgGetSavedShippingAddress();
  var payload = saved.zip ? saved : data;
  if (!saved.zip && data) {
    cgSaveShippingAddress(data);
  }
  if (payload && payload.zip) {
    cgApplyZipToAllInputs(payload.zip);
  }
  if (typeof ShippingCalc === 'function') {
    window.__cgAsmThruTries = 0;
    ShippingCalcThru();
  }
}

var __cgCartRateRefreshTimer = null;

function cgAsmRestoreResultsAfterCartUpdate(attempt) {
  attempt = attempt || 0;

  if (window.__cgSkipCartGeo) {
    if (attempt < 40) {
      setTimeout(function () {
        cgAsmRestoreResultsAfterCartUpdate(attempt + 1);
      }, 100);
    }
    return;
  }

  var saved = cgGetSavedShippingAddress();
  if (saved.zip) {
    cgApplyZipToAllInputs(saved.zip);
  }
  syncGlobalZipToInstances();

  var cartInstances = document.querySelectorAll(
    '.asm-shipping-calc[data-asm-instance="cart-drawer"], .asm-shipping-calc[data-asm-instance="cart-page"], .asm-shipping-calc[data-asm-context="cart"]'
  );

  // First add-to-cart: drawer calc may not be in the DOM until section morph finishes.
  if (!cartInstances.length && attempt < 20) {
    setTimeout(function () {
      cgAsmRestoreResultsAfterCartUpdate(attempt + 1);
    }, 150);
    return;
  }

  if (!cartInstances.length) return;

  var zip = (saved && saved.zip) || (getVisibleCalcZip() && getVisibleCalcZip().value);
  if (!zip) {
    if (attempt < 20) {
      setTimeout(function () {
        cgAsmRestoreResultsAfterCartUpdate(attempt + 1);
      }, 150);
    }
    return;
  }

  // Debounce — cart:update often fires more than once during morph.
  if (__cgCartRateRefreshTimer) clearTimeout(__cgCartRateRefreshTimer);
  __cgCartRateRefreshTimer = setTimeout(function () {
    var zipNow = (cgGetSavedShippingAddress().zip) || (getVisibleCalcZip() && getVisibleCalcZip().value);
    if (!zipNow) return;

    var instancesNow = document.querySelectorAll(
      '.asm-shipping-calc[data-asm-instance="cart-drawer"], .asm-shipping-calc[data-asm-instance="cart-page"], .asm-shipping-calc[data-asm-context="cart"]'
    );
    console.log('[ASM calc] Refreshing cart shipping estimate(s) from Shopify full-cart rates');
    instancesNow.forEach(function (cartInstance) {
      var cartResults = cartInstance.querySelector('#calc_results, [data-asm-results]');
      if (cartResults) {
        cgFillPdpRateFromShopify(cartResults, zipNow, { isolate: false });
      }
    });
  }, 50);
}

document.addEventListener('input', function (event) {
  if (!event.target.matches('[data-asm-zip-input]')) return;

  var globalZip = getVisibleCalcZip();
  if (globalZip && event.target !== globalZip) {
    globalZip.value = event.target.value;
  }
});

if (!window.__cgAsmDrawerEditBound) {
  window.__cgAsmDrawerEditBound = true;
  document.addEventListener('click', function (event) {
    var submitButton = event.target.closest('[data-asm-calc-submit]');
    if (submitButton) {
      cgAsmCalcSubmit(submitButton.closest('.asm-shipping-calc'));
      return;
    }

    var drawerEdit = event.target.closest('#cart-drawer-edit-asm-addr');
    if (drawerEdit) {
      event.preventDefault();
      var drawerInstance = drawerEdit.closest('.asm-shipping-calc');
      var saved = cgGetSavedShippingAddress();
      if (saved.zip) cgApplyZipToAllInputs(saved.zip);
      cgAsmToggleEditForInstance(drawerInstance, event);
      return;
    }

    var editLink = event.target.closest('[data-asm-calc-edit]');
    if (editLink) {
      cgAsmToggleEditForInstance(editLink.closest('.asm-shipping-calc'), event);
    }
  });
}

document.addEventListener('cart:update', function () {
  // Morph often finishes after the first frame; run once soon and once after settle.
  requestAnimationFrame(function () {
    cgAsmRestoreResultsAfterCartUpdate(0);
  });
  setTimeout(function () {
    cgAsmRestoreResultsAfterCartUpdate(0);
  }, 350);
});

function cgAsmBoot() {
  if (window.__cgAsmBooted) return;
  window.__cgAsmBooted = true;

  cgWatchHiddenAsmInject();
  cgDeduplicateAsmCalcIds();
  var saved = cgGetSavedShippingAddress();
  if (saved.zip) {
    cgApplyZipToAllInputs(saved.zip);
  }
  copyZipValue();
  pdpAsmCalcObserver();

  if (document.querySelector('.asm-shipping-calc') && !saved.zip) {
    cgAsmGeolocationScript(
      'https://www.advancedshippingmanager.com/clients/customizations/city_grounds_geolocation_lookup.php?callback=cgAsmPopulatePdpCalcFields'
    );
  } else if (saved.zip) {
    CityGroundsInit();
  }

  // Cart drawer/page must show full-cart rates, independent of the PDP estimate.
  if (document.querySelector('.asm-shipping-calc[data-asm-context="cart"]')) {
    setTimeout(function () {
      cgAsmRestoreResultsAfterCartUpdate(0);
    }, 400);
  }
}

document.addEventListener('DOMContentLoaded', cgAsmBoot);

if (document.readyState !== 'loading') {
  cgAsmBoot();
}

/** EOF ASM widget customizations */
